import {
  ActivityIcon,
  DatasetIcon,
  ExperimentIcon,
  GraphIcon,
  VolumeIcon,
  WorkspaceIcon,
} from '@assets/icons';
import { Group } from '@components/layout';
import { Typography } from '@components/typography';
import { Stack, useTheme } from '@mui/material';
import { useOrganizationContext } from '@navigation/OrganizationContext';
import { useWorkspaceContext } from '@navigation/WorkspaceContext';
import { navigate } from 'gatsby';
import { NavDivider } from './NavDivider';
import { SideNavButton } from './SideNavButton';

export const WorkspaceNav = ({ selectedTab }: { selectedTab: string }) => {
  const { palette } = useTheme();
  const { organizationId, organization } = useOrganizationContext();
  const { workspaceId, workspace } = useWorkspaceContext();
  if (!workspaceId || organization?.serviceOnly) {
    return null;
  }
  return (
    <Stack sx={{ width: '100%' }}>
      <NavDivider />
      <Group alignItems="center" sx={{ mx: 1, my: 1 }}>
        <Typography variant="caption2" handleOverFlow color={palette.grey[200]}>
          {workspace?.name}
        </Typography>
      </Group>
      <SideNavButton
        Icon={WorkspaceIcon}
        onClick={() => navigate(`/${organizationId}/workspaces/${workspaceId}`)}
        label="Workspace home"
        selected={selectedTab === 'workspace-home'}
      />
      <SideNavButton
        Icon={VolumeIcon}
        onClick={() => navigate(`/${organizationId}/workspaces/${workspaceId}/volumes`)}
        label="Volumes"
        selected={selectedTab === 'workspace-volumes'}
      />
      <SideNavButton
        Icon={GraphIcon}
        onClick={() => navigate(`/${organizationId}/workspaces/${workspaceId}/graphs`)}
        label="Graphs"
        selected={selectedTab === 'workspace-graphs'}
      />
      <SideNavButton
        Icon={ActivityIcon}
        onClick={() => navigate(`/${organizationId}/workspaces/${workspaceId}/jobs`)}
        label="Jobs"
        selected={selectedTab === 'workspace-jobs'}
      />
      <SideNavButton
        Icon={DatasetIcon}
        onClick={() => navigate(`/${organizationId}/workspaces/${workspaceId}/datasets`)}
        label="Datasets"
        selected={selectedTab === 'workspace-datasets'}
      />
      <SideNavButton
        Icon={ExperimentIcon}
        onClick={() => navigate(`/${organizationId}/workspaces/${workspaceId}/experiments`)}
        label="Experiments"
        selected={selectedTab === 'workspace-experiments'}
      />
    </Stack>
  );
};
